import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import { image } from '../../../utils/data/baseUrl';
import { useTranslation } from '../../../translations';

const TutorialModalItem = React.forwardRef(function TutorialItem({ title, text, index, img, noBg }, ref) {
  const { t } = useTranslation();

  return (
    <div className={'tutorial-modal__item tutorial-modal__item_' + (index + 1)} ref={ref}>
      {img && (
        <div className={'tutorial-modal__item-image'}>
          {!noBg && (
            <img className={'tutorial-modal__item-image-bg'} src={image('tutorialModal/bg-2.png')} alt={'img-bg'} />
          )}
          <img className={'tutorial-modal__item-image-img'} src={img} alt={'winners-img'} />
        </div>
      )}
      <h2 className='tutorial-modal__item-title'>{safeHTML(t(title))}</h2>
      <p className='tutorial-modal__item-text'>{safeHTML(t(text))}</p>
    </div>
  );
});
export default TutorialModalItem;
TutorialModalItem.propTypes = {};
